import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/new';
// eslint-disable-next-line check-choreographer-usage/no-import-in-product-messages-without-choreographer
import ModalDialog, {
	CloseButton,
	ModalFooter,
	ModalBody,
	ModalTitle,
	ModalHeader,
} from '@atlaskit/modal-dialog';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, xcss } from '@atlaskit/primitives';

import { fg } from '@confluence/feature-gating';

import { messages } from '../../messages.ts';

type IssueCreateWarningDialogProps = {
	onConfirm: () => void;
	onCancel?: () => void;
	issuesCount?: number;
};

const headerStyles = xcss({
	flexDirection: 'row-reverse',
	width: '100%',
	justifyContent: 'space-between',
});

const footerStyles = xcss({
	display: 'flex',
	justifyContent: 'flex-end',
	flex: 1,
	gap: 'space.050',
});

export const IssueCreateWarningDialog: FC<IssueCreateWarningDialogProps> = ({
	onConfirm,
	onCancel,
	issuesCount = 1,
}) => {
	const handleConfirm = () => {
		onConfirm();
	};

	const handleCancel = () => {
		if (onCancel) {
			onCancel();
		}
	};

	const Footer = () => {
		return (
			<ModalFooter>
				<Inline xcss={footerStyles}>
					<Button testId="issue-create-warning-cancel-button" onClick={handleCancel}>
						<FormattedMessage {...messages.unsavedActionCancel} />
					</Button>
					<Button
						testId="issue-create-warning-ok-button"
						appearance="warning"
						onClick={handleConfirm}
					>
						<FormattedMessage {...messages.unsavedActionDiscard} />
					</Button>
				</Inline>
			</ModalFooter>
		);
	};

	return (
		<FormattedMessage
			{...(fg('confluence-issue-terminology-refresh')
				? messages.unsavedHeadingIssueTermRefresh
				: messages.unsavedHeading)}
			values={{ issuesCount }}
		>
			{(text) => (
				<ModalDialog testId="modal-dialog-issue-create-warning">
					<ModalHeader>
						<Inline xcss={headerStyles}>
							<CloseButton onClick={handleCancel} />
							<ModalTitle appearance="warning">{text}</ModalTitle>
						</Inline>
					</ModalHeader>

					<ModalBody>
						<FormattedMessage
							{...(fg('confluence-issue-terminology-refresh')
								? messages.unsavedContentIssueTermRefresh
								: messages.unsavedContent)}
							values={{ issuesCount }}
						/>
					</ModalBody>
					<Footer />
				</ModalDialog>
			)}
		</FormattedMessage>
	);
};
